import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-16" }
const _hoisted_2 = { class: "flex w-full items-center" }
const _hoisted_3 = { class: "mr-16" }
const _hoisted_4 = { class: "flex flex-1 flex-col" }
const _hoisted_5 = { class: "flex justify-between gap-8" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "text-14 font-medium" }
const _hoisted_8 = { name: "add" }
const _hoisted_9 = ["name"]
const _hoisted_10 = { class: "flex items-center justify-between" }
const _hoisted_11 = { class: "flex items-baseline gap-x-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-12 text-black-400"
}
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "relative mt-8 grid grid-cols-2 gap-8 border-b border-beige bg-cream/20 px-8 py-12 tablet:grid-cols-3" }
const _hoisted_15 = { class: "flex items-center text-10 text-black-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_image = _resolveComponent("v-image")
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_image, {
          lazyloaded: "",
          source: $props.item.image,
          class: "h-[6.375rem] w-[4.815rem] object-cover"
        }, null, 8, ["source"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: $props.item.url,
            class: "flex"
          }, [
            _createElementVNode("span", _hoisted_7, _toDisplayString($props.item.title), 1)
          ], 8, _hoisted_6),
          _createElementVNode("form", {
            ref: "deleteKitForm",
            onSubmit: _cache[0] || (_cache[0] = _withModifiers($event => ($options.deleteKit($event)), ["prevent"]))
          }, [
            _createElementVNode("button", _hoisted_8, [
              _createVNode(_component_v_icon, {
                icon: "trash",
                width: 18,
                height: 18,
                color: "#605F5F"
              })
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$props.item, ...$props.item.components], ({key}, index) => {
              return (_openBlock(), _createElementBlock("input", {
                key: index,
                type: "hidden",
                name: `updates[${key}]`,
                value: 0
              }, null, 8, _hoisted_9))
            }), 128))
          ], 544)
        ]),
        ($data.locale.deliverable_at in $props.item.properties)
          ? (_openBlock(), _createElementBlock("small", {
              key: 0,
              class: "mb-4 text-[0.6875rem] italic tracking-wide",
              style: _normalizeStyle(`color: ${$data.unavailableProductColor}`)
            }, _toDisplayString($data.locale.deliverable_at) + " " + _toDisplayString($props.item.properties[`${$data.locale.deliverable_at}`]), 5))
          : (_openBlock(), _createElementBlock("small", {
              key: 1,
              class: "mb-4 text-[0.6875rem] italic tracking-wide",
              style: _normalizeStyle(`color: ${$data.availableProductColor}`)
            }, _toDisplayString($data.locale.available_now), 5)),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            ($options.compareAtPrice > $options.price)
              ? (_openBlock(), _createElementBlock("del", _hoisted_12, _toDisplayString($options.compareAtPrice), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["text-14 font-medium", $data.skeletonClass])
            }, _toDisplayString($options.price), 3)
          ]),
          _createElementVNode("button", {
            class: "btn-accent btn-xsmall text-12 font-normal text-black-0/70 after:!bottom-2 after:!h-[0.031rem]",
            onClickOnce: _cache[1] || (_cache[1] = $event => ($options.editKit())),
            textContent: _toDisplayString($data.locale.edit_kit)
          }, null, 40, _hoisted_13)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.components, (component) => {
        return (_openBlock(), _createElementBlock("div", {
          key: component[0].key,
          class: "flex items-center gap-x-8 bg-cream/60 [&_picture]:aspect-cart-kit-item [&_picture]:h-52 [&_picture]:w-36 [&_picture]:shrink-0"
        }, [
          _createVNode(_component_v_image, {
            lazyloaded: "",
            source: component[0].image,
            class: "h-full w-full object-cover"
          }, null, 8, ["source"]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(component.length) + "x " + _toDisplayString(component[0].product_title), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}